module.exports = __webpack_public_path__ + "img/graph-up.9474cd7c.svg";